export default __webpack_public_path__ + "c71a5bd.png";